import mobileThreatsS1 from "@/assets/png/MobileThreats/mobileThreatsS1.png";
import mobileThreatsS2 from "@/assets/png/MobileThreats/mobileThreatsS2.png";
import mobileThreatsS3 from "@/assets/png/MobileThreats/mobileThreatsS3.png";
import mobileThreatsS4 from "@/assets/png/MobileThreats/mobileThreatsS4.png";
import mobileThreatsS5 from "@/assets/png/MobileThreats/mobileThreatsS5.png";
import mobileThreatsS6 from "@/assets/png/MobileThreats/mobileThreatsS6.png";
import mobileThreatsS7 from "@/assets/png/MobileThreats/mobileThreatsS7.png";

import { Answer, IQuizList, ISlides } from "@/pages/SecurityAwareness/types";

export const mobileThreatsQuiz: Array<IQuizList> = [
  {
    name: "step1",
    question: "1. What is smishing?",
    options: [
      { value: "1", label: "Phishing via email on mobile" },
      { value: "2", label: "Malware that infects Android apps" },
      {
        value: Answer.Correct,
        label: "Phishing through SMS messages",
      },
      { value: "4", label: "A VPN bypass technique" },
    ],
  },
  {
    name: "step2",
    question: "2. Which of the following is a common mobile threat vector?",
    options: [
      { value: "1", label: "Using Bluetooth headphones" },
      {
        value: Answer.Correct,
        label: "Connecting to unsecured public Wi-Fi",
      },
      { value: "3", label: "Taking screenshots" },
      { value: "4", label: "Using airplane mode" },
    ],
  },
  {
    name: "step3",
    question: "3. What is a good security practice when working remotely?",
    options: [
      { value: "1", label: "Disabling device passcode for convenience" },
      {
        value: Answer.Correct,
        label: "Using a VPN on public Wi-Fi and enabling auto-lock",
      },
      { value: "3", label: "Installing apps from third-party APK sites" },
      { value: "4", label: "Mixing work and personal data freely" },
    ],
  },
  {
    name: "step4",
    question: "4. What happened in the smishing example in the training?",
    options: [
      { value: "1", label: "The attacker hijacked a phone number" },
      {
        value: Answer.Correct,
        label: "Employee gave credentials to a fake IT login page",
      },
      { value: "3", label: "The device was remotely wiped" },
      { value: "4", label: "VPN failed to connect" },
    ],
  },
  {
    name: "step5",
    question: "5. What should you do if your device is lost or stolen?",
    options: [
      { value: "1", label: "Ignore it unless something happens" },
      {
        value: Answer.Correct,
        label: "Report it immediately and trigger remote-wipe if available",
      },
      { value: "3", label: "Post about it on social media" },
      { value: "4", label: "Disable OS updates to prevent tracking" },
    ],
  },
];

export const mobileThreatsSlides: Array<ISlides> = [
  { id: 1, content: <img src={mobileThreatsS1} alt="slide1" /> },
  { id: 2, content: <img src={mobileThreatsS2} alt="slide2" /> },
  { id: 3, content: <img src={mobileThreatsS3} alt="slide3" /> },
  { id: 4, content: <img src={mobileThreatsS4} alt="slide4" /> },
  { id: 5, content: <img src={mobileThreatsS5} alt="slide5" /> },
  { id: 6, content: <img src={mobileThreatsS6} alt="slide6" /> },
  { id: 7, content: <img src={mobileThreatsS7} alt="slide7" /> },
];
